<div class="create-education create-education-two">
    <div class="create-education-wrap">
        <div class="create-education-left">
            <h2>Certificaciones</h2>
        </div>

        <div class="create-education-right">
            <a (click)="mostrarEdicionCertificacion()">+ Añadir Certificación</a>
        </div>
    </div>

    <div>
        <div class="container" *ngIf="!mostrarEdicion">
            <div class="row" *ngFor="let certificacion of certifiaciones  | paginate: { itemsPerPage: 1, currentPage: noPagina }">
                <div class="offset-2 col-lg-8 offset-2">
                    <div class="form-group">
                        <label>Título del Certificado</label>
                        <input type="text" class="form-control" [value]="certificacion.nombre" readonly>
                    </div>
                </div>

                <div class="offset-2 col-lg-4">
                    <div class="form-group">
                      <label>Año de Emisión</label>
                      <input type="text" class="form-control" [value]="certificacion.anio" readonly>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Empresa Emitida</label>
                        <input type="text" class="form-control" [value]="certificacion.empresa" readonly>
                    </div>
                </div>

                <div class="offset-2 col-lg-8 offset-2">
                    <div class="form-group">
                        <div class="text-left">
                            <button type="button" class="btn btn-default-ac" (click)="habilitarEdicion(certificacion)">Editar Actual</button>
                            <button type="button" class="btn btn-default-ac" (click)="eliminarCertificacionCandidato(certificacion.idCertificacion)">Eliminar Actual</button>
                        </div>
                    </div>
                </div>

                <div class="aling-center">
                    <pagination-controls class="page-numbers" (pageChange)="noPagina = $event"
                        [responsive]="true" [previousLabel]="''" [nextLabel]="''"></pagination-controls>
                </div>
            </div>
        </div>

        <div class="container" *ngIf="mostrarEdicion">
            <form [formGroup]="formCer" (ngSubmit)="validarExperiencia()">
                <div class="row">
                    <div class="offset-2 col-lg-8 offset-2">
                        <div class="form-group">
                            <label>Título del Certificado</label>
                            <input type="text" class="form-control" formControlName="nombre" [placeholder]="certificacionCandidato.nombre || 'Certificación Programador Java'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCer.controls.nombre.errors &&
                                (formCer.controls.nombre.dirty || formCer.controls.nombre.touched)">
                                <div *ngIf="formCer.controls.nombre.errors.required">El títilo de la certificación es requerida.</div>
                            </div>
                        </div>
                    </div>

                    <div class="offset-2 col-lg-4">
                        <div class="form-group">
                            <label>Año de Emisión</label>
                            <input type="text" maxlength="4" class="form-control" formControlName="anio" [placeholder]="certificacionCandidato.anio || 'Año de termino'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCer.controls.anio.errors &&
                                (formCer.controls.anio.dirty || formCer.controls.anio.touched)">
                                <div *ngIf="formCer.controls.anio.errors.pattern">Solo se permiten números.</div>
                                <div *ngIf="formCer.controls.anio.errors.maxlength">El año de emisión solo debe contener como máximo 4 dígitos.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Empresa Emitida</label>
                            <input type="text" class="form-control" formControlName="empresa" [placeholder]="certificacionCandidato.empresa || 'Tec Gurus'">
                            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCer.controls.empresa.errors &&
                                (formCer.controls.empresa.dirty || formCer.controls.empresa.touched)">
                                <div *ngIf="formCer.controls.empresa.errors.required">El nombre de la empresa ó institución es requerido.</div>
                            </div>
                        </div>
                    </div>

                    <div class="offset-2 col-lg-8 offset-2">
                        <div class="form-group">
                            <div class="text-left">
                                <button type="submit" class="btn create-ac-btn">{{(editarCertificacion ? 'Actualizar' : 'Agregar')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
